module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAIbEAACGxAAGFqWwEAAAAsElEQVRIx2NgGK6AkUxMEAQA8Qsg/kcmfgnEQfgsABn+n0L8Gl+w/CPCAGJ8wkyOBRuAWByImYjAZPlAgsQEQJIF/6AuA6n5DcR/CeA/2IKJWAv+EhlPFFsAohcA8XwsllLFggVIeufQwoL5SHpn0yqI5kINp0kQ0TySqWrBf2guZiAyJzORk5PXAbEopXUAMYXdXyIwMy5LXlKhuH6DzxdB0PKcEsNDiAkuZjLxMAQAImIGj1vqOeMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/wallet.png
// module id = Uarh
// module chunks = 12